import { NepNowDateFormat, NowNepaliYearName } from "../../../../widgets/DateFormat";
import { useFormik } from "formik";
import { ViewBtn } from "../../../../widgets/AppBtn";
import { Grid } from "@mui/material";
import InputTextBox from "../../../../widgets/InputTextBox";
import SelectionBox from "../../../../widgets/SelectionBox";
import { MonthOptions } from "../../../../widgets/Options";

const PartimeSalayFullTimeSalarySearchView = ({PayrollListView}) => {
  // PayrollListView
  const DefaultYearNam = NowNepaliYearName();
  const currentDates_ = NepNowDateFormat();

  const initialValues = {
    date: currentDates_ || "",

    yearr: DefaultYearNam || "",
    monthh: "",

    monthh_name: "",
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      PayrollListView(values?.monthh, values.yearr);
    },
  });
  return (
    <div className="bg-white dark:bg-slate800 shodow rounded-md p-5">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={0.5}>
          <Grid item xl={4} md={4} lg={4} sm={6} xs={12}>
            <InputTextBox
              label="Year"
              type="text"
              name="yearr"
              value={values.yearr}
              handleChange={handleChange}
              handleBlur={handleBlur}
              touched={touched.yearr}
              errors={errors.yearr}
              required={true}
            />
          </Grid>
          <Grid item xl={4} md={4} lg={4} sm={6} xs={12}>
            <SelectionBox
              label="Month"
              options={MonthOptions}
              name="monthh"
              value={values.monthh}
              optionSelect={(fieldName, data) => {
                setFieldValue("monthh", data?.value);
                setFieldValue("monthh_name", data?.label);
              }}
              handleBlur={handleBlur}
              touched={touched.monthh}
              errors={errors.monthh}
              required={true}
              disabled={false}
            />
          </Grid>
          <Grid item xl={4} md={4} lg={4} sm={6} xs={12}>
            <div className="flex mt-5 gap-3 justify-end">
              <ViewBtn
                type="button"
                onClick={async () =>
                  await PayrollListView(values?.monthh, values.yearr)
                }
              />
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default PartimeSalayFullTimeSalarySearchView;
